import {BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError} from '@reduxjs/toolkit/dist/query/react';
import { ENDPOINTS } from '../common/endpoints';
import { tagTypes } from './TagTypes';
import {AccountDeletion, canRequestInReadOnly, getAccountDeletion, getAccountDeletionRevision, resetAccountDeletion, setAccountDeletion} from '../models/AccountDeletion';

const rawBaseQuery = fetchBaseQuery({
    baseUrl: ENDPOINTS.BASE_API_URL,
    credentials: 'include',
});

const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
    const method = typeof args === 'string' ? 'GET' : args.method || 'GET';
    if (getAccountDeletion().isReadOnly && !canRequestInReadOnly(api.endpoint, method)) {
        return {error: {status: 403, data: {code: 'account.read_only'}}};
    }
    const revision = getAccountDeletionRevision();
    const result = await rawBaseQuery(args, api, extraOptions);
    if (result.data && ['getAuthContext', 'getUserData', 'logIn', 'getAccountDeletion', 'requestAccountDeletion', 'cancelAccountDeletion'].includes(api.endpoint)) {
        const data = result.data as {accountDeletion?: AccountDeletion; isReadOnly?: boolean};
        const deletion = data.accountDeletion || data;
        if (typeof deletion.isReadOnly === 'boolean' && (revision === getAccountDeletionRevision() || api.type === 'mutation')) setAccountDeletion(deletion as AccountDeletion);
        if (api.endpoint === 'getAuthContext' && 'isAuthenticated' in data && !data.isAuthenticated) resetAccountDeletion();
        if (api.endpoint === 'cancelAccountDeletion') window.dispatchEvent(new CustomEvent('bakery:account-restored'));
    }
    const errorData = result.error?.data;
    const errorCode = errorData && typeof errorData === 'object' && 'code' in errorData ? errorData.code : undefined;
    const isSessionProbe = api.endpoint === 'getAuthContext';
    if (result.error?.status === 403 && errorCode === 'account.read_only') {
        setAccountDeletion({...getAccountDeletion(), isReadOnly: true});
        window.dispatchEvent(new CustomEvent('bakery:account-read-only'));
    }
    if (result.error?.status === 401 && errorCode === 'account.deletion_due') {
        resetAccountDeletion();
        window.dispatchEvent(new CustomEvent('bakery:unauthorized', {detail: result.error.data}));
    }
    if (!result.error && api.endpoint === 'logOut') resetAccountDeletion();
    if (result.error?.status === 401 && errorCode !== 'account.deletion_due' && errorCode !== 'auth.invalid_credentials' && api.endpoint !== 'logIn' && !isSessionProbe && typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('bakery:unauthorized', {detail: result.error.data}));
    }
    return result;
};

export const baseAPI = createApi({
    reducerPath: 'baseAPI',
    baseQuery,
    tagTypes,

    endpoints: (build) => ({}),
});
